import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import UserDetailsContext from "../../context/auth";
const Rolecreatelist = () => {
  const navigate = useNavigate();

  const { user, AccessData } = useContext(UserDetailsContext);
  const id = user?.id;

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [wfhList, setWfhList] = useState([]);

  useEffect(() => {
    onWfhSubmit();
  }, []);

  const wfhListTable = {
    columns: [
      {
        field: "role",
        headerName: "Role",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },

      {
        field: "description",
        headerName: "Description",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: (wfhList || []).map((wfh) => ({
      id: wfh.id,
      role: wfh.role,
      description: wfh.description,
    })),
  };

  const handleNewWfh = () => {
    navigate("/rollcreationlist/rollcreation");
  };
  const onWfhListClick = (e) => {
    // console.log('onWfhListClick:', e?.id, e);
    if (e?.id) {
      navigate(`/rollcreationlist/rollcreation?id=${e?.id}`);
    }
  };
  const onWfhSubmit = async () => {
    const query = `query{
  allRoles{
    data{
      id
      role
      description
    }
  }
}`;

    const encodedId = btoa(user?.id);
    let data = "VXNlck5vZGU6" + "" + encodedId;
    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract department data from the response
      const wfhList = response.data.data.allRoles[0]?.data;
      console.log("wfhList:", wfhList);

      setWfhList(wfhList);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Role Creation List
                </MaterialTypography>
                {/* <MaterialTypography variant="caption" color="text">
                                List of WFH that you can get details of WFH.
                            </MaterialTypography> */}
              </Stack>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddRole" &&
                    item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewWfh()}
                  >
                    ROLE CREATION
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
         customHeight={550}
          rows={wfhListTable.rows}
          columns={wfhListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onWfhListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Role Creations data found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any Work From Home details. Click on
                  the "Add Work From Home" button to start adding Work From Home
                  details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Rolecreatelist;
